<template>
  <section
    v-if="tab === 7 && answer"
    id="answerSection"
    class="user-information p-4 bg-white box-shaddow20 border-r-10"
  >
    <div class="d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center gap-5 custom-border-right px-2">
        <ContactIcon />
        <h4 class="font-w-400 font-s-18 text-color-theme-dark m-0">
          پاسخ تماس با ما
        </h4>
      </div>
    </div>

    <b-skeleton-table
      v-if="status"
      :rows="5"
      :columns="4"
      :table-props="{ bordered: false, striped: false }"
    ></b-skeleton-table>
    <template v-else>
      <div v-for="item in answer.data" :key="item.id">
        <details>
          <summary>
            <div class="summary-chevron-up">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-down"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            {{ item.body }}
          </summary>
          <p v-if="item.answer" class="summary-content">
            {{ item.answer }}
          </p>
          <p v-else class="summary-content">هنوز پاسخی داده نشده است</p>
        </details>
      </div>
      <div class="w-100 text-center py-5" v-if="answer.data.length === 0">
        <svg
          width="66"
          height="65"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.00866 14.1252C8.85033 14.1252 8.69199 14.0669 8.56699 13.9419L7.31699 12.6919C7.07533 12.4502 7.07533 12.0502 7.31699 11.8085C7.55866 11.5669 7.95866 11.5669 8.20033 11.8085L9.00866 12.6169L11.9003 9.7252C12.142 9.48353 12.542 9.48353 12.7837 9.7252C13.0253 9.96686 13.0253 10.3669 12.7837 10.6085L9.45033 13.9419C9.33366 14.0669 9.16699 14.1252 9.00866 14.1252Z"
            fill="#C4C1C1"
          />
          <path
            d="M11.667 5.62533H8.33366C7.53366 5.62533 6.04199 5.62533 6.04199 3.33366C6.04199 1.04199 7.53366 1.04199 8.33366 1.04199H11.667C12.467 1.04199 13.9587 1.04199 13.9587 3.33366C13.9587 4.13366 13.9587 5.62533 11.667 5.62533ZM8.33366 2.29199C7.50866 2.29199 7.29199 2.29199 7.29199 3.33366C7.29199 4.37533 7.50866 4.37533 8.33366 4.37533H11.667C12.7087 4.37533 12.7087 4.15866 12.7087 3.33366C12.7087 2.29199 12.492 2.29199 11.667 2.29199H8.33366Z"
            fill="#C4C1C1"
          />
          <path
            d="M12.5 18.9587H7.5C2.81667 18.9587 1.875 16.8087 1.875 13.3337V8.33368C1.875 4.53368 3.25 2.90868 6.63333 2.73368C6.975 2.71702 7.275 2.97535 7.29167 3.32535C7.30833 3.67535 7.04167 3.95868 6.7 3.97535C4.33333 4.10868 3.125 4.81702 3.125 8.33368V13.3337C3.125 16.417 3.73333 17.7087 7.5 17.7087H12.5C16.2667 17.7087 16.875 16.417 16.875 13.3337V8.33368C16.875 4.81702 15.6667 4.10868 13.3 3.97535C12.9583 3.95868 12.6917 3.65868 12.7083 3.31702C12.725 2.97535 13.0167 2.70868 13.3667 2.72535C16.75 2.90868 18.125 4.53368 18.125 8.32535V13.3253C18.125 16.8087 17.1833 18.9587 12.5 18.9587Z"
            fill="#C4C1C1"
          />
        </svg>
        <h5 class="font-w-500 font-s-18 text-color-theme-grey2 mt-3">
          اطلاعاتی در دسترس نمی باشد
        </h5>
      </div>
    </template>
    <section
      id="mainPaginationBlog"
      v-if="answer && answer.last_page > 1"
      class="weblog-list-pagination text-center my-4 p-2 bg-color-fa"
    >
      <section
        v-if="answer"
        id="listPagination"
        class="list-pagination weblog-list-pagination text-center my-4 py-2"
      >
        <pagination
          :limit="1"
          :data="answer"
          @pagination-change-page="changePage"
          :disabled="status"
          class="justify-content-center"
        >
          <span slot="prev-nav">
            <ZPrevSvg />
          </span>
          <span slot="next-nav">
            <ZNextSvg />
          </span>
        </pagination>
      </section>
    </section>
  </section>
</template>
<script>
import paginationMixin from "@/libraries/mixins/paginationMixin";
import ZPrevSvg from "@/parts/Front/components/shared/ZPrevSvg";
import ZNextSvg from "@/parts/Front/components/shared/ZNextSvg";
import LineGrow from "@/parts/Front/components/shared/LineGrow";
import { BRow, BCol, BSkeletonTable } from "bootstrap-vue";
import ContactIcon from "@/parts/Front/components/Icon/panelIcons/Contact.vue";
export default {
  mixins: [paginationMixin],
  props: { tab: { Number } },
  components: {
    LineGrow,
    ZNextSvg,
    ZPrevSvg,
    BRow,
    BCol,
    BSkeletonTable,
    ContactIcon,
  },
  data() {
    return {
      loading: false,
      allow: false,
    };
  },
  computed: {
    status() {
      return this.$store.getters["front/getAnswerStatus"];
    },
    answer() {
      return this.$store.getters["front/getAnswer"];
    },
  },

  // created() {
  //   if(this.answer == null){
  //     this.$store.dispatch(
  //     "front/getAnswerFromServer",
  //     this.$route.query.page != undefined ? this.$route.query.page : "1"
  //   );
  //   }
  // },

  mounted() {
    setTimeout(() => {
      this.allow = true;
    }, 5000);

    if (!this.answer) {
      this.$store.dispatch(
        "front/getAnswerFromServer",
        this.$route.query.page != undefined ? this.$route.query.page : "1"
      );
    }
  },

  watch: {
    answer(newVal) {
      if (newVal != null) {
        this.loading = true;
      }
    },

    "$route.query.page": {
      handler: function (val) {
        let page = val;
        if (this.allow) this.$store.dispatch("front/getAnswerFromServer", page);
        document
          .getElementById("answerSection")
          .scrollIntoView({ behavior: "smooth" });
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
details {
  font-size: 1rem;
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.1),
    0 5px 5px -5px rgba(0, 0, 0, 0.04);
  width: 97%;
  margin: 2rem auto;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
  position: relative;
}
details:hover {
  cursor: pointer;
}
details .summary-content {
  border-top: 1px solid #e2e8f0;
  font-family: "Yekan Bakh Regular";
  cursor: default;
  padding: 1em;
  font-weight: 300;
  line-height: 1.5;
  background-color: rgb(238, 236, 236);
}
details summary {
  list-style: none;
  padding: 1rem 2rem 1rem 1rem;
  font-family: "Yekan Bakh Regular";
  font-weight: 300;
  line-height: 1.5;
}
details .summary-chevron-up {
  pointer-events: none;
  position: absolute;
  right: 4px;
  top: 15px;
}
details summary:hover .summary-chevron-up svg {
  opacity: 1;
}
details .summary-chevron-up svg {
  opacity: 0.5;
}
details .summary-chevron-up svg {
  display: block;
}
details > summary::-webkit-details-marker {
  display: none;
}
</style>
